import { useState, useEffect } from 'react';

export function useExtensionDetected(): boolean {
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.type === 'CROSOVA_EXTENSION_INSTALLED') {
        setDetected(true);
      }
    };

    window.addEventListener('message', handler);

    // Ping the extension in case its content script loaded before this listener.
    // The bridge replies with CROSOVA_EXTENSION_INSTALLED.
    const ping = () => window.postMessage({ type: 'CROSOVA_PING' }, '*');
    ping();
    const t1 = setTimeout(ping, 300);
    const t2 = setTimeout(ping, 1000);

    return () => {
      window.removeEventListener('message', handler);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return detected;
}

interface ExtensionListing {
  title: string;
  description: string;
  price: number;
  condition: string;
  brand?: string;
  size?: string;
  colour?: string;
  tags?: string[];
  photos: string[];
}

export function triggerExtensionCrosslist(
  jobId: string,
  listing: ExtensionListing,
  platform: string,
) {
  const apiBase = import.meta.env.VITE_API_URL?.replace(/\/api\/v1$/, '') ?? 'http://localhost:4000';

  window.postMessage({
    type: 'CROSOVA_CROSSLIST',
    jobId,
    listing,
    platform,
    apiBase,
  }, '*');
}

export function triggerExtensionDelist(
  jobId: string,
  platform: string,
  itemUrl: string,
  externalId: string | null,
) {
  const apiBase = import.meta.env.VITE_API_URL?.replace(/\/api\/v1$/, '') ?? 'http://localhost:4000';

  window.postMessage({
    type: 'CROSOVA_DELIST',
    jobId,
    platform,
    itemUrl,
    externalId,
    apiBase,
  }, '*');
}

export const EXTENSION_PLATFORMS = ['vinted', 'depop'];

export function isExtensionPlatform(platform: string): boolean {
  return EXTENSION_PLATFORMS.includes(platform);
}
